import { Injectable } from '@angular/core';
import CryptoES from 'crypto-es';
import { CypherGateway } from 'src/app/domain/models/cypher/gateway/cypher-gateway';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CypherService extends CypherGateway {
  private CipherPassphrase = CryptoES.enc.Hex.parse(environment.CipherPassphrase);
  private CipherOptions = {
    keySize: 128 / 8,
    iv: this.CipherPassphrase,
    mode: CryptoES.mode.CBC,
    padding: CryptoES.pad.Pkcs7
  }

  constructor() {
    super();
   }

  EncryptText(text : string) : string {
    return CryptoES.AES.encrypt(CryptoES.enc.Utf8.parse(text), this.CipherPassphrase, this.CipherOptions).toString();
  }

  DecryptText(text : string) : string {
    return CryptoES.AES.decrypt(text, this.CipherPassphrase, this.CipherOptions).toString(CryptoES.enc.Utf8);
  }

  EncryptObject(object : Object) : string {
    return CryptoES.AES.encrypt(JSON.stringify(object), this.CipherPassphrase, this.CipherOptions).toString();
  }
    
  DecryptObject(hash: string): any {
    if(hash?.length) {
      let object = CryptoES.enc.Utf8.stringify(CryptoES.AES.decrypt(hash,  this.CipherPassphrase, this.CipherOptions));
      if(object.length) {
        return JSON.parse(object);
      }
    }
    return null;
  }

}